//=============================================
// ARCHELIOS MAP NAMESPACE
// # 2963
//=============================================
var am = (function(module) {
    //Use strict mode
    'use strict';

    /**
     * Class simulating a thermal solar panel installation
     */
    module.ThermalCombinedInstallation = function() {
        // Private attributes
        this._roofModel = undefined; // reference to the object computing the solar potential of the selected roof sides
        this._params = undefined;    // parameters
        this._properties = {};
    };

    /**
     * Class constructor
     * @constructor
     *
     * @param {am.ModelBaseClass} roofModel - Reference to the SolarPotentialModel instance to be used in order to 
     *      compute the solar potential of the PV panel installation.
     * @param {Object} params - Object configuration. The following keys are required:
     *      - dailyHotWaterConsumptionPerInhabitant: [l/day/pers.] 
     *      - solarPanelSurfacePerInhabitant: [m²/pers.] 
     *      - waterHeatingTemperature: [°C] 
     *      - monthlyDJU_18 : [Array(°C)]
     *      - monthlyMeanAirTemperature : [Array(°C)]
     *      - profiles.prod : [-]
     *      - solarPanelConbinedSurfacePerHeatingSurface : [m²/m²]
     *
     */
    module.ThermalCombinedInstallation.prototype.init = function(roofModel, params) {
        this._roofModel = roofModel;
        this._params = params;

        this._params.numberOfDaysPerMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        this._params.CpECS =1.16;// Wh/litre/K
      
        //"dailyHotWaterConsumptionPerInhabitant"
	    //"solarPanelSurfacePerInhabitant":
	    //"waterHeatingTemperature"
        this._params.CoefFSC ={
            a:0.2168,
            b:0.2822,
            c:0.0803
        }
        this._params.rendement_max=0.7; /* rendement = taux_économie/FSC */


        this._params.monthProfile=[];
        var oProfile=this._params.profiles.prod;
        var iIndex =0;
        for(var m=0;m<12;m++){
           var sommeMonth=0;
            for(var day=0;day<this._params.numberOfDaysPerMonth[m];day++){
                for(var hour=0;hour<24;hour++){
                    sommeMonth+=oProfile.values[iIndex];
                    iIndex++;
                }
            }
            this._params.monthProfile.push(sommeMonth/oProfile.somme);
        }
    }

     /**
     * Computes the characteristics of the thermal panel installation. The surface of the thermal solar panels is computed so as
     * to optimize the discounted net profit at the end of the observation period.
     *
     * @param {Object} userInfos - Information about the (future) owner of the thermal installation. This object must 
     *      contain the following keys:
     *          - numberOfInhabitants : [-]
     *          - classeDPE : [STRING] Etiquette Energie, de A à G
     *          - heatingSystemType : [STRING] "Electrique", "PAC", "Gaz", "Bois/Biomasse", "Autre"
     *          - numberOfFloors : [-] Number of floors in the building
     */
    module.ThermalCombinedInstallation.prototype.computeProperties = function(userInfos) {

        if(!userInfos.hasOwnProperty('thermalType') || userInfos.thermalType!="combined")
            return;

        // === Living surface ===
        var buildingSurfaceArea = this._roofModel.getProperty("buildingGroundArea");
        var livingSurface = buildingSurfaceArea * userInfos.numberOfFloors;
        if (userInfos.hasUserBuildingSurfaceArea){
            livingSurface = userInfos.userBuildingSurfaceArea;
        }

        // ==== Panel surface ===
        var maxPanelSurface = this._roofModel.getProperty("maxAvailablePanelSurface").thermal;
        var panelSurfaceUnit = 2; // m² (size of one thermal solar panel)
        // Compute the surface of solar panels to be installed
        var panelSurface = Math.max(panelSurfaceUnit, livingSurface*this._params.solarPanelConbinedSurfacePerHeatingSurface); // first guess, in m²
        panelSurface = Math.round(panelSurface / panelSurfaceUnit) * panelSurfaceUnit; // make the panel surface a multiple of panelSurfaceUnit
        if (panelSurface > maxPanelSurface) {
            panelSurface = Math.floor(maxPanelSurface / panelSurfaceUnit) * panelSurfaceUnit;
        }

        // ==== Water volume ===
        var volumeECS= this._params.dailyHotWaterConsumptionPerInhabitant*userInfos.numberOfInhabitants;


        // === Systemes type ===
        var appointType = userInfos.heatingSystemType;
        var heatingType= appointType;
        if(heatingType=="Electrique" || heatingType=="PAC")
            heatingType="Electricité";



        // === Month Irrad ===
        // var meanIrrad = this._roofModel.getProperty("meanSpecificAnnualSolarEnergy");
        this._roofModel.computeAnnualIrradiation({
            "panelSurface": panelSurface,
            "isFlatRoof": userInfos.hasOwnProperty('isFlatRoof') && userInfos.isFlatRoof
        }, "thermal");
        var annualSolarPotential = this._roofModel.getProperty("totalAnnualSolarEnergy");
        var monthIrradA =[];
        for(var m=0;m<12;m++){
            monthIrradA.push(annualSolarPotential*this._params.monthProfile[m])
        }

        //---------calculation---------------
        var rendementAppoint=this._computeRendementAppoint(appointType);
        var consosCh_A=this._computeAnnualConsoCh(userInfos.classeDPE,livingSurface,heatingType);
        var consosCh_M=this._computeMonthConsoCh(consosCh_A,this._params.monthlyDJU_18);

        var totalConso=0;//Cumul annuel consommations de référence
        var totalConsoECS=0;
        var totalConsoAppoint=0;
        var totalConsoAppointECS=0;

        //Boucle sur les mois
        for(var m=0;m<12;m++){
            //Calcul température eau froide (pour ECS)
            var tempColdWater=this._computeTempColdWater(this._params.monthlyMeanAirTemperature,this._params.monthlyMeanAirTemperature[m]);

            //Besoins ECS journaliers
            var dailyNeedECS=this._computeDailyNeedECS(this._params.CpECS,volumeECS,this._params.waterHeatingTemperature,tempColdWater);

            var monthECSNeed = dailyNeedECS*this._params.numberOfDaysPerMonth[m];
            var monthChNeed = consosCh_M[m]*rendementAppoint;
            //Besoins de référence
            var monthNeed =monthECSNeed+monthChNeed;

            var ECSNeedRatio =monthECSNeed/monthNeed;

            //Consommations de référence
            var monthConso=monthNeed/rendementAppoint;
            totalConso+=monthConso;
            totalConsoECS+=monthConso*ECSNeedRatio;

            var maxUseIrrad =monthIrradA[m]//*panelSurface;
            if(maxUseIrrad>monthConso)
                maxUseIrrad=monthConso;

            var FSC =maxUseIrrad/monthConso; //Calcul des Fractions Solarisables des Consommations*
            var tauxEco=this._computeTauxEco(this._params.CoefFSC.a,this._params.CoefFSC.b,this._params.CoefFSC.c,FSC) //Taux d'économie
            var rendementConbined=tauxEco/FSC;/*Rendement mensuel du système SSC*/
            if(rendementConbined>this._params.rendement_max)
                tauxEco=FSC*this._params.rendement_max;

            var monthConsoAppoint=monthConso*(1-tauxEco);
            totalConsoAppoint+=monthConsoAppoint;
            totalConsoAppointECS+=monthConsoAppoint*ECSNeedRatio;
        }

        var totalCouv=(totalConso -totalConsoAppoint)/totalConso;
        var totalCouvECS=(totalConsoECS -totalConsoAppointECS)/totalConsoECS;
        var totalCouvCH=((totalConso-totalConsoECS) -(totalConsoAppoint-totalConsoAppointECS))/(totalConso-totalConsoECS);
        // console.log("Conso de référence : "+Math.round(totalConso)+" kWh");
        // console.log("Economie : "+Math.round(totalConso -totalConsoAppoint)+" kWh");
        // console.log("Appoint : "+Math.round(totalConsoAppoint)+" kWh")
        // console.log("taux de couverture : "+Math.round(totalCouv*100)+"%");
        // console.log("taux de couverture ECS: "+Math.round(totalCouvECS*100)+"%");
        // console.log("taux de couverture CH : "+Math.round(totalCouvCH*100)+"%");


        // Compute the economical figures
        var economicalFigures = this._computeEconomicalParameters(panelSurface, totalConso, totalConsoAppoint, totalCouv, totalCouvECS, totalCouvCH, userInfos);


        // Store the thermal panel installation characteristics
        this._properties.combinedSurface = panelSurface;
        this._properties.combinedObservationPeriod = this._params.economics_combined.observationYears;
        // for (var key in economicalFigures) {
        //     this._properties[key] = economicalFigures[key];
        // }

        this._properties['economicsResults'] = {
            'combined' : economicalFigures
        }

        // this._properties['economicsResults']['thermal']['thermalPanelSurface'] = panelSurface;
        this._properties['economicsResults']['combined']['observationPeriod'] = this._params.economics_combined.observationYears;
    }


    /**
     * Compute the economical figures of the panel installation project
     *
     */
    module.ThermalCombinedInstallation.prototype._computeEconomicalParameters = function(solarPanelSurfaceArea, totalConso, totalConsoAppoint,totalCouv, totalCouvECS, totalCouvCH, userInfos) {
        //---------economics---------------
        var params = this._params.economics_combined;

        // Compute the installation cost
        var fRawInvest = params.panelInstallationCost.fixedPart+params.panelInstallationCost.variablePart*solarPanelSurfaceArea;

        // Compute subvention
        var totalSubvention = 0;
        if (params.hasOwnProperty('subventionRate')) {
            var subRate=params.subventionRate[userInfos.userCategory].rate;
            var subMax=params.subventionRate[userInfos.userCategory].maxCredit;
            if(subMax==null)
                subMax=Infinity;

            totalSubvention += Math.min(subRate*fRawInvest,subMax);
        } else if (params.hasOwnProperty('subsidy')) {
            var subsidy = params.subsidy[userInfos.userCategory];
            if (typeof subsidy === 'number') {
                totalSubvention += subsidy;
            }
        }

        // Add the VAT
        var vatRate = params.hasOwnProperty('installationTvaRate') ? params.installationTvaRate :
                      this._params.hasOwnProperty('installationTvaRate') ? this._params.installationTvaRate : 
                      this._params.tvaRate;
        if (typeof vatRate === 'object' && vatRate.hasOwnProperty(userInfos.userCategory)) {
            vatRate = vatRate[userInfos.userCategory];
        }
        if (vatRate !== undefined && vatRate > 0) {
            fRawInvest *= 1 + vatRate;
        }

        // Ticket #3998 : Net Investment = Raw Investment - Total Subventions
        var fInitInvest = fRawInvest - totalSubvention;

        // ================================
        // ==== Procesing of the credit ===
        // ================================

        var simulateBankLoan = userInfos.hasOwnProperty('simulateBankLoan') ? userInfos.simulateBankLoan : true;

        // Compute the personal funds and the borrowed amount
        var borrowedAmountPercentage, fInvestBorrowed, fOwnFunds;
        if (simulateBankLoan) {
            borrowedAmountPercentage =  params.creditInitialAmountPercentage || 0;
            if ((userInfos.combinedBorrowedPercentage >= 0) && (userInfos.combinedBorrowedPercentage <= 100)) {
                borrowedAmountPercentage = userInfos.combinedBorrowedPercentage / 100;//#2311
            }
            fInvestBorrowed = fInitInvest * borrowedAmountPercentage;//[75% of fInitInvest]
            fOwnFunds = fInitInvest - fInvestBorrowed ;
            if (userInfos.hasOwnProperty('creditPersonalFunds')) {
                fOwnFunds = Math.min(userInfos.creditPersonalFunds, fInitInvest);
                fInvestBorrowed = fInitInvest - fOwnFunds;
                borrowedAmountPercentage = fInvestBorrowed / fInitInvest;
            }
        } else {
            fOwnFunds = fInitInvest;
            fInvestBorrowed = 0;
            borrowedAmountPercentage = 0;
        }

        // converting the annual rate % into a numeric monthly rate
        var fCreditYearlyRate = params.hasOwnProperty('creditYearlyRate') ? params.creditYearlyRate : 3; // 3% default value
        var fCreditMonthlyRate = fCreditYearlyRate / 1200. ; // monthly rate

        var fCreditDurationInYears = params.hasOwnProperty('creditDurationInYears') ? params.creditDurationInYears : 20; // default to 20 years
        var fCreditDurationInMonths = fCreditDurationInYears * 12;

        var _fCoef = Math.pow(1.+fCreditMonthlyRate, fCreditDurationInMonths) ;

        var _nMonthlyRepayment;
        if ( fCreditMonthlyRate > 1.e-7 )
            _nMonthlyRepayment = fInvestBorrowed * fCreditMonthlyRate * _fCoef / (_fCoef-1.) ;
        else
            _nMonthlyRepayment = fInvestBorrowed / fCreditDurationInMonths ;

        // var capital = fInitInvest ;
        var _nPaidAmount = fCreditDurationInMonths*_nMonthlyRepayment ;
        var _nInterestAmount = _nPaidAmount-fInvestBorrowed ;

        // var _nCashAmount = fOwnFunds / fCreditDurationInMonths ;

        var _nEndingCapital = Math.round(this.capital_fin( fInvestBorrowed, _nMonthlyRepayment, fCreditMonthlyRate, fCreditDurationInMonths )) ;

        // console.log('==================================');
        // console.log('pourcentage emprunte', borrowedAmountPercentage);
        // console.log('capital total', installationCost);
        // console.log('capital apport', installationCost - fInvestBorrowed);
        // console.log('capital emprunt', fInvestBorrowed);
        // console.log('remboursement annuel cash', _nCashAmount * 12);
        // console.log('remboursement annuel credit', _nMonthlyRepayment * 12);
        // console.log('remboursement annuel total', (_nMonthlyRepayment + _nCashAmount) * 12);
        // console.log('montant_verse', _nPaidAmount);
        // console.log('montant_interet', _nInterestAmount);
        // console.log('[verification] capital_fin', _nEndingCapital);
        // console.log('==================================');


        // Compute the annual maintenance cost
        var fAnnualMaintenanceCost = 0;
        for (var iThreshold = 0, nThresholds = params.maintenanceCost.variablePart.length; iThreshold < nThresholds; ++iThreshold) {
            var threshold = params.maintenanceCost.variablePart[iThreshold];
            var thresholdSurface = (threshold.maxSurface == null) ? Infinity : threshold.maxSurface;
            if (solarPanelSurfaceArea <= thresholdSurface) {
                fAnnualMaintenanceCost = threshold.annualCostPerM2 * solarPanelSurfaceArea;
                break;
            }
        }
        fAnnualMaintenanceCost = Math.max(params.maintenanceCost.minValue, fAnnualMaintenanceCost);
        var annualMoneySavings = params.energyBuyCost[userInfos.heatingSystemType].price*(totalConso -totalConsoAppoint);
        var gainAnnualFactor = (1 + params.energyBuyCost[userInfos.heatingSystemType].inflation) / (1 + this._params.economics_global.actualisationRate);
        var gainTotalFactor = (gainAnnualFactor == 1) ? params.observationYears : (Math.pow(gainAnnualFactor, params.observationYears + 1) - gainAnnualFactor) / (gainAnnualFactor - 1);
        var fBillSavingsOverPeriod = annualMoneySavings * gainTotalFactor;
        var costAnnualFactor = (1 + this._params.economics_global.inflation) / (1 + this._params.economics_global.actualisationRate);
        var costTotalFactor = (costAnnualFactor == 1) ? params.observationYears : (Math.pow(costAnnualFactor, params.observationYears + 1) - costAnnualFactor) / (costAnnualFactor - 1);
        var maintenanceCostOverPeriod = fAnnualMaintenanceCost * costTotalFactor;

        var fIncomeOverPeriod = 0;

        // Ticket #3998 : Raw Profit = (Income + Savings)
        var fRawProfitOverPeriod = fIncomeOverPeriod + fBillSavingsOverPeriod;

        // Ticket #3998 : Spendings = Maintenance + Costs + repayment loan
        var fSpendingsOverPeriod = maintenanceCostOverPeriod + _nPaidAmount;

        // Ticket #3998 : Net incomings = Raw Profit - Spendings
        var fNetIncomingOverPeriod = fRawProfitOverPeriod - fSpendingsOverPeriod;

        // Ticket #3998 : Net Profit = Raw Profit - Spendings
        var fNetProfitOverPeriod = fNetIncomingOverPeriod - fOwnFunds;

        // Ticket #3998 : ROI : Own funds * Duration / net profit
        var fROI = (fNetProfitOverPeriod <=0) ? Number.POSITIVE_INFINITY : (fOwnFunds) / Math.max(fNetIncomingOverPeriod, 0) * params.observationYears;

        // var netProfit = fBillSavingsOverPeriod - maintenanceCostOverPeriod - installationCost;

        // Taux de rentabilité d'un investissement ayant la même VAN que le projet solaire
        var rateOfReturn = Math.pow(Math.max(1, (fRawProfitOverPeriod - maintenanceCostOverPeriod - _nInterestAmount) / fInitInvest), 1 / params.observationYears) - 1;


        return {
            panelSurface: solarPanelSurfaceArea,
            rawInstallationCost:               fRawInvest,
            installationCost:                  fInitInvest,
            borrowedAmount:                    fInvestBorrowed,
            borrowedPercentage:                borrowedAmountPercentage,
            creditCost:                        _nInterestAmount,
            creditAmount:                      _nPaidAmount,
            creditPeriod:                      fCreditDurationInYears,
            ownFunds:                          fOwnFunds,
            spendingsOverPeriod:               fSpendingsOverPeriod,
            billSavingsOverPeriod:             fBillSavingsOverPeriod,
            incomingOverPeriod:                fIncomeOverPeriod,
            maintenanceCostOverPeriod:         maintenanceCostOverPeriod,
            rawProfitOverPeriod:               Math.max(fRawProfitOverPeriod, 0),
            netProfitOverPeriod:               Math.max(fNetProfitOverPeriod, 0), // in euros
            totalSubventionOverPeriod:         totalSubvention,
            annualHotWaterNeedsCoverageRate:   totalCouvECS,
            annualHeatNeedsCoverageRate:       totalCouvCH,
            returnOnInvestment:                fROI,
            observationPeriod:                 params.observationYears,
            rateOfReturn:                      rateOfReturn
        }
        
    };


    module.ThermalCombinedInstallation.prototype.capital_fin = function( c0, m, t, n ) {
        var cn;
        if ( t > 1.e-7 ) {
            var coef = Math.pow(1.+t,n) ;
            cn = coef*(c0-m/t) + m/t ;
        } else {
            // coef ~ 1+n*t
            cn = c0 -n*m ;
        }
        return cn ;
    }


     /**
     * Returns the properties of the thermal panel installation
     *
     * @return {Objet} - Installation properties. This object has the following keys:
     *      - conbinedPanelSurface : [m²]
     *     
     */
    module.ThermalCombinedInstallation.prototype.getProperties = function() {
        return this._properties;
    };

    //----------------------------------Rendement de l'appoint------------------------------
    module.ThermalCombinedInstallation.prototype._computeRendementAppoint = function (TypeAppoint){
        switch(TypeAppoint){
            case "Electrique": var Rendement_appoint=0.9;break;
            case "PAC": var Rendement_appoint=2;break;
            case "Gaz":	var Rendement_appoint=0.85;break;
            case "Bois/Biomasse": var Rendement_appoint=0.8;break;
            case "Autre": var Rendement_appoint=0.7;break;
        }
        return Rendement_appoint;
    }

    //--------------------------------Calcul des besoins de chauffage----------------------------
    module.ThermalCombinedInstallation.prototype._computeAnnualConsoCh = function (ClasseDPE,Surf_hab,EnergieChauffage){
        /*Calcul de la consommation annuelle de chauffage (en énergie finale) à partir de la classe du DPE, de la surface habitable et du type de chauffage*/
        switch(ClasseDPE){
            /*valeurs moyennes des classes*/
            case "A": var Consos_A=50;break;
            case "B": var Consos_A=70;break;
            case "C": var Consos_A=120;break;
            case "D": var Consos_A=190;break;
            case "E": var Consos_A=280;break;
            case "F": var Consos_A=390;break;
            case "G": var Consos_A=500;break;
        }

        switch(EnergieChauffage){
            /*Part du chauffage dans le bilan global ; moyenne de la base DPE*/
            case "Bois/Biomasse": var Part_Ch=0.43;break;
            case "Electricité": var Part_Ch=0.61;break;
            case "Gaz": var Part_Ch=0.75;break;
            case "Autre": var Part_Ch=0.73;break;
        }

        var Consos_Ch=Consos_A*Part_Ch*Surf_hab;
        if (EnergieChauffage=="Electricité"){
            Consos_Ch=Consos_Ch/2.58;
        }

        return Consos_Ch;
    }

    module.ThermalCombinedInstallation.prototype._computeMonthConsoCh = function (ConsosCh_A,Tab_DJU_M){
        /*Répartition des besoins de chauffage mois par mois*/
        var Cumul_DJU=0;
        var BesoinsCh_M=[];
        for (var m=0;m<12;m++){
            if (m>=4 && m<=8){/*Pas de chauffage de mai à septembre*/
                Cumul_DJU=Cumul_DJU;
            }
            else{
                Cumul_DJU=Cumul_DJU+Tab_DJU_M[m];
            }		
        }
        for (var m=0;m<12;m++){
            if (m>=4 && m<=8){
                BesoinsCh_M[m]=0;
            }
            else{
                BesoinsCh_M[m]=ConsosCh_A*Tab_DJU_M[m]/Cumul_DJU
                }
        }
        return BesoinsCh_M
    }


    module.ThermalCombinedInstallation.prototype._computeTempColdWater = function (Tab_TExt_M,TExt_M){
        /*calcul de la température d'eau froide pour un mois donné (page 27)*/
        var n=Tab_TExt_M.length;
        var somme=0;
        for (var i=0;i<n;i++){somme+=Tab_TExt_M[i];}
        var Text_A=somme/n;
        var TEF_M=3+(TExt_M+Text_A)/2;
        return TEF_M;
    }

    module.ThermalCombinedInstallation.prototype._computeTauxEco = function (a,b,c,FSC){
        var taux_economie=a*Math.pow(FSC,2)+b*FSC+c;
	    return taux_economie;
    }

    module.ThermalCombinedInstallation.prototype._computeDailyNeedECS = function (CpECS,VECS_Pro_JM,TECS_Pro_M,TEF_M){
        /*Calcul du besoin énergétique de production d'eau chaude (page 27)*/ 
        var BECS_Pro_JM=CpECS*VECS_Pro_JM*(TECS_Pro_M-TEF_M)/1000 //besoin journalier d'eau chaude en kWh/jr
        return BECS_Pro_JM;
    }
    
    return module;

})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Returns a new instance of class am.ThermalPanelInstallation
     *
     * @param {am.ModelBaseClass} roofModel - Reference to the SolarPotentialModel instance to be used in order to 
     *      compute the solar potential of the PV panel installation.
     * @param {Object} params - Object configuration (see constructor of class am.ThermalPanelInstallation for more information)
     * @return {am.ThermalPanelInstallation} - New instance of class am.ThermalPanelInstallation 
     */
    module.thermalCombinedInstallation = function(roofModel, params) {
        var model = new am.ThermalCombinedInstallation();
        model.init(roofModel, params);
        return model;
    };

    return module;

})(am.utils || {});